<ph-dialog open [heading]="title" (ph-close)="cancel()">
    <p *ngIf="isAchCancellation; else voidCheck">
        This action will cancel the ACH payment to this vendor.
        Are you sure you want to continue?
    </p>

    <ng-template #voidCheck>
        <ph-alert status="information">
            <ng-container *ngIf="isMarkedAsPaid; else checkVoidCopy">
                This only records this payment as voided in PayHOA.
                Since the payment was made outside of PayHOA, you will also need to reverse it directly with your bank or the vendor.
            </ng-container>
            <ng-template #checkVoidCopy>
                This only records the check as voided in PayHOA.
                To ensure the check cannot be cashed, you will also need to request a stop payment through your bank.
            </ng-template>
        </ph-alert>
        <div>Voiding this payment will reverse its payment entry and return this invoice to unpaid.</div>
        <ng-container *ngIf="showsPaymentEntry">
            <ph-skeleton *ngIf="paymentEntryLoading; else paymentEntryTable"
                         shape="table"
                         rows="2"
                         columns="3"
                         label="Loading the payment entry"></ph-skeleton>
            <ng-template #paymentEntryTable>
                <ph-data-table *ngIf="paymentEntryRows.length"
                               label="Payment entry"
                               layout="table"
                               columns-menu="false"
                               density="compact"
                               sticky-header="false"
                               [columns]="paymentEntryColumns"
                               [rows]="paymentEntryRows"
                               [footer]="paymentEntryFooter"></ph-data-table>
            </ng-template>
        </ng-container>
        <form [formGroup]="form">
            <ph-field>
                <ph-label>Void Date</ph-label>
                <ph-date-input formControlName="cancellationDate" ngDefaultControl [max]="maxDateStr"></ph-date-input>
                <ph-hint>Select the date to reflect the void date in the reversal transaction.</ph-hint>
            </ph-field>
        </form>
    </ng-template>

    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" mode="filled" (click)="cancel()">Cancel</ph-button>
        <ph-button variant="error" mode="filled" (click)="confirm()">{{ confirmButtonText }}</ph-button>
    </ph-actions>
</ph-dialog>
